import Resource, { createResourceHook } from '@tabeo/resync'
import api from '@tabeo/sharpei/utils/api'
import normalize from './normalizers/transaction'

class Transactions extends Resource {
  getInitialData() {
    return {
      items: null,
      totalCount: 0,
    }
  }

  getInitialConfig() {
    return {
      refreshInterval: 60 * 1000,
    }
  }

  async fetch(query) {
    const {
      conditions = [],
      searchQuery = query,
      limit = 10,
      offset = 0,
      orderBy: { field, direction } = { field: 'id', direction: 'desc' },
    } = this.params

    // merchant.merchantRateCards feeds the nl_ifinance feeAmount derivation in
    // the transaction normalizer (getMerchantRateCards throws without it).
    const subResource =
      '&subResource=paymentPlans.lender&subResource=merchant.merchantRateCards'
    const jsonConditions = `&jsonConditions=${encodeURIComponent(
      JSON.stringify(conditions)
    )}`
    const pagination = `&limit=${limit}&offset=${offset}`
    const endpoint = searchQuery
      ? `/offer-search?order=${field}:${direction}&searchPhrase=${encodeURIComponent(
          searchQuery
        )}${subResource}`
      : `/offers?order=${field}:${direction}${subResource}`

    const {
      data: { offers },
      totalCount,
    } = await api.get(
      `${endpoint}${jsonConditions}${pagination}&subResource=merchant`,
      {
        responseDataPath: 'data',
      }
    )

    const normalizedTransactions = offers.map(o => normalize(o))

    const data = {
      totalCount,
      items: normalizedTransactions,
    }

    this.data = data

    return data
  }
}

export default Transactions
export const useTransactions = createResourceHook(Transactions)
